import React, { useEffect, useState } from "react";
import { Button, Row } from "react-bootstrap";
import { GET_DATA_PROPERTIES, GET_DATA_PROPERTY_CATEGORIES, GET_DATA_PROPERTY_TYPES, GET_DATA_PROPERTY_UNITS } from "../../../queries";
import Sidebar2 from "../../Sidebar2";
import { TitleSource } from "../teleporters/Title";
import RegisterPropertiesForm from "./Properties/RegisterPropertiesForm";
import PropertiesProfile from "./Properties/PropertiesProfile";
import PropertiesList from "./Properties/PropertiesList";

const DataProperties = (props:any) => {
    console.log('DataProperties props', props);
    let orgId = props.currentUser.orgId;
    
    const [showSidebar, setShowSidebar] = useState<boolean>(false);
    const [selectedProperty, setSelectedProperty] = useState<any>(null);
    const [properties, setProperties] = useState<any>([]);
    const [propertyUnits, setPropertyUnits] = useState<any>([]);
    const [propertyCategories, setPropertyCategories] = useState<any>([]);
    const [propertyTypes, setPropertyTypes] = useState<any>([]);
    const [showCreateProperty, setShowCreateProperty] = useState<boolean>(false);

    useEffect(() => {
        loadProperties();
    }, []);

    useEffect(() => {
        loadPropertyUnits();
    }, []);
        
    useEffect(() => {
        loadPropertyCategories();
    }, []);

    useEffect(() => {
        loadPropertyTypes();
    }, []);

    const loadProperties = () => {
        var data = {
            org_id: orgId
        };
        props.client.query({
            query: GET_DATA_PROPERTIES,
            variables: data,
            fetchPolicy: "no-cache"
        }).then((result: any) => {
            console.log("result data properties", result)
            setProperties(transform(result.data));
        });
    }

    const loadPropertyUnits = () => {
        props.client.query({
            query: GET_DATA_PROPERTY_UNITS,
            //variables: data,
            fetchPolicy: "no-cache"
        }).then((result: any) => {
            console.log("result property units", result)
            setPropertyUnits(transformUnits(result.data));
        });
    }

    const loadPropertyCategories = () => {
        var data = {
            org_id: orgId
        };
        props.client.query({
            query: GET_DATA_PROPERTY_CATEGORIES,
            variables: data,
            fetchPolicy: "no-cache"
        }).then((result: any) => {
            console.log("result property categories", result)
            setPropertyCategories(transformCategories(result.data));
        });
    }

    const loadPropertyTypes = () => {
        props.client.query({
            query: GET_DATA_PROPERTY_TYPES,
            //variables: data,
            fetchPolicy: "no-cache"
        }).then((result: any) => {
            console.log("result property types", result)
            setPropertyTypes(transformTypes(result.data));
        });
    }

    const transform = (data: any) => {
        let orgProperties = data.syncarto_dw_property;

        return orgProperties.map((item: any) => {

            return {
                name: item.name,
                shortcode: item.shortcode,
                category_name: item.property_category ? item.property_category.name : <i>NULL</i>,
                category_id: item.category_id,
                type_name: item.property_type ? item.property_type.name : <i>NULL</i>,
                type_id: item.type_id,
                id: item.id
            }
        });
    }
    
    const transformUnits = (data: any) => {
        let propertyUnits = data.syncarto_dw_unit;
        let propertyUnitsTransformed:any = [];
        propertyUnitsTransformed[0] = {
            name: "None",
            id: null,
            unit_type_id: null,
            abbrv: null,
        }
        for (var u in propertyUnits){
            let item = propertyUnits[u];
            propertyUnitsTransformed[item.id] = {
                name: item.name,
                id: item.id,
                unit_type_id: item.unit_type_id,
                abbrv: item.abbrv,
            }
        }
        console.log("propertyUnitsTransformed", propertyUnitsTransformed);
        return propertyUnitsTransformed;
    }     
    const transformCategories = (data: any) => {
        let propertyCategories = data.syncarto_dw_property_category;
        let propertyCategoriesTransformed:any = [];
        propertyCategoriesTransformed[0] = {
            name: "None",
            id: null,
        }
        for (var u in propertyCategories){
            let item = propertyCategories[u];
            propertyCategoriesTransformed[item.id] = {
                name: item.name,
                id: item.id,
            }
        }
        console.log("propertyCategoriesTransformed", propertyCategoriesTransformed);
        return propertyCategoriesTransformed;
    }    
    
    const transformTypes = (data: any) => {
        let propertyTypes = data.syncarto_dw_property_type;
        let propertyTypesTransformed:any = [];
        propertyTypesTransformed[0] = {
            name: "None",
            id: null,
        }
        for (var u in propertyTypes){
            let item = propertyTypes[u];
            propertyTypesTransformed[item.id] = {
                name: item.name,
                id: item.id,
            }
        }
        console.log("propertyTypesTransformed", propertyTypesTransformed);
        return propertyTypesTransformed;
    }

    const onSelectedPropertyId = (propertyId:any) => {
        console.log("onSelectedPropertyId > propertyId", propertyId)
        setShowCreateProperty(false);
        setSelectedProperty(propertyId);
        setShowSidebar(true);
    }

    const onSidebarHide = (propertyId:any) => {
        setShowSidebar(false);
    }

    const shouldRefreshProperties = () => {
        loadProperties();
    }

    const loadFormOptions = () => {
       
        const optionsFor_property_type = propertyTypes;  

        const optionsFor_property_category = propertyCategories;

        const optionsFor_property_unit = propertyUnits;

        const formOptions = {
            "optionsFor_property_category": optionsFor_property_category,
            "optionsFor_property_type": optionsFor_property_type,
            "optionsFor_property_unit": optionsFor_property_unit,
        }
        console.log("formOptions", formOptions)
        return formOptions;
    }

    const onShowCreateProperties = (e:any) => {
        e.preventDefault();
        setSelectedProperty(null);
        setShowCreateProperty(true);
        setShowSidebar(true);
    }
    let formOptions = loadFormOptions();
    return (
        <div className="m-2-syncarto m-4">
            <TitleSource><h4 className="m-0 mt-1">Data - Properties</h4></TitleSource>  

            <div>
                <PropertiesList orgId={orgId} properties={properties} onSelectedPropertyId={onSelectedPropertyId} {...props}></PropertiesList>
                {<Button 
                    variant="primary"
                    onClick={onShowCreateProperties}>
                        Create Property
                </Button>} 
            </div>  
            {<Sidebar2 width={550} show={showSidebar} onHide={onSidebarHide} >
                {selectedProperty && <PropertiesProfile orgId={orgId} propertyId={selectedProperty} shouldRefreshProperties={shouldRefreshProperties} formOptions={formOptions} {...props}></PropertiesProfile>}
                {showCreateProperty && <RegisterPropertiesForm orgId={orgId} shouldRefreshProperties={shouldRefreshProperties} formOptions={formOptions} {...props}></RegisterPropertiesForm>}
            </Sidebar2>}
        </div>
    );
}

export default DataProperties;